import { toast } from "sonner";
import { Wordmark, scrollToId, openApp } from "./Navbar";
import { StoreBadges } from "./DownloadCTA";

const placeholder = (name) => toast.info(`${name} coming soon`, { description: "This page will be published alongside the app launch." });

export default function Footer() {
  return (
    <footer className="bg-[#0F2A22] pb-10 pt-16 text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.2fr_1fr_1fr_1.3fr]">
          <div>
            <Wordmark light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-emerald-100/70">
              Your personal and professional productivity assistant. Tasks, reminders, calendars and more — just ask.
            </p>
          </div>

          <div>
            <p className="font-heading text-sm font-bold uppercase tracking-widest text-lime-300">Product</p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-emerald-100/80">
              <button data-testid="footer-link-features" onClick={() => scrollToId("features")} className="w-fit hover:text-white">Features</button>
              <button data-testid="footer-link-how-it-works" onClick={() => scrollToId("how-it-works")} className="w-fit hover:text-white">How It Works</button>
              <button data-testid="footer-link-privacy-security" onClick={() => scrollToId("privacy")} className="w-fit hover:text-white">Privacy & Security</button>
              <button data-testid="footer-link-open-godigo" onClick={openApp} className="w-fit hover:text-white">Open GoDiGo</button>
            </div>
          </div>

          <div>
            <p className="font-heading text-sm font-bold uppercase tracking-widest text-lime-300">Company</p>
            <div className="mt-4 flex flex-col gap-3 text-sm text-emerald-100/80">
              <button data-testid="footer-link-privacy-policy" onClick={() => placeholder("Privacy Policy")} className="w-fit hover:text-white">Privacy Policy</button>
              <button data-testid="footer-link-terms" onClick={() => placeholder("Terms of Service")} className="w-fit hover:text-white">Terms of Service</button>
              <button data-testid="footer-link-support" onClick={() => scrollToId("support")} className="w-fit hover:text-white">Support</button>
              <button data-testid="footer-link-contact" onClick={() => scrollToId("support")} className="w-fit hover:text-white">Contact</button>
            </div>
          </div>

          <div>
            <p className="font-heading text-sm font-bold uppercase tracking-widest text-lime-300">Get the app</p>
            <div className="mt-4">
              <StoreBadges testPrefix="footer" />
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-emerald-100/60" data-testid="footer-copyright">© {new Date().getFullYear()} GoDiGo. All rights reserved.</p>
          <p className="font-serif-accent text-sm italic text-emerald-100/50">Your life. Organized.</p>
        </div>
      </div>
    </footer>
  );
}
